import I18n from 'I18n';
import { View } from 'foundations-components/components/View';

// @ts-expect-error untyped module
import DSProvider from 'customer-data-filters/components/fetcher/DSProvider';
import ReenrollmentStep from 'automation-ui-canvas/create/steps/ReenrollmentStep';
import UnenrollmentStep from 'automation-ui-canvas/create/steps/UnenrollmentStep';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EnrollmentSettingsStep(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ReenrollmentStep, Object.assign({}, props)), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "400"
    }), /*#__PURE__*/_jsx(DSProvider, {
      children: /*#__PURE__*/_jsx(UnenrollmentStep, Object.assign({}, props))
    })]
  });
}
export const enrollmentSettingsStep = {
  component: EnrollmentSettingsStep,
  getLabel: () => I18n.text('createWorkflow.step.enrollmentSettings')
};